import type { FaireProductEntity } from "../../entity_types/product";

export const p_nm8cq573vu: FaireProductEntity = {
  token: "p_nm8cq573vu",
  type: "product",
  name: "Herbal First Aid & Essential Remedies kit",
  brandToken: "b_yjgecwdpju",
  brandName: "WHOLIFECO",
  imageUrl:
    "https://cdn.faire.com/fastly/f13105957b3214dd7e712a052ca500744e2aaaa3de44d9d147799899bb05d9fd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/273f4620ba74afe32bad9cf24c42c8bf5416601fd17cf2a992d88883d6c1d1e3.png",
    "https://cdn.faire.com/fastly/91be86e66196ad7551427a29608e83c78590def8b6153984468509431a9e7851.png",
  ],
  priceDollars: 69.21,
  description:
    " Herbal First Aid & Essential Remedies Kit – Nature’s Healing at Your Fingertips\n\nEvery home should have a natural first-aid kit, and our Herbal First Aid & Essential Remedies kit is designed to provide holistic, plant-based solutions for everyday wellness. From soothing minor cuts and burns to supporting immunity and digestion, these time-tested herbal remedies offer gentle yet effective relief without synthetic ingredients.\n\n What’s Inside of the kit?\n\nSoothing skin balm (4oz) – Herbal balm for minor cuts, scrapes, irritation and most skin issues.\nImmuniTea Boost (1oz)– Tea blend to strengthen and protect the body.\n Tummy comfort tea (1oz)– Natural remedies for bloating, nausea, and indigestion.\n InflammaEase tea (1oz)– Tea blend known for easing discomfort, pain, inflammation and muscle tension.\n Seasonal defense tea (1oz)– Tea blend to open airways and soothe seasonal congestion.\n\nAllerZen tea(1oz) - tea blend to ease common allergies.\n\nActivated charcoal(4oz)- Ultimate remedy for food poisoning.\n\nSweet Dreams tea(1oz) -Tea blend for restful sleep.\n\nThis kit is a must-have for every household, combining the wisdom of plant medicine with the power of holistic healing. Keep your family prepared, protected, and naturally supported because your wellness starts at home. \n\nGrab yours today & build your natural medicine cabinet!\n",
  tags: [],
  msrpDollars: 98.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:32.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
